export const productFilterCompaction = {
  gsm: { heading: "Exact GSM / thickness", visibleLimit: 6, alwaysVisible: ["Thickness-led"] },
  width: { heading: "Width", visibleLimit: 5, alwaysVisible: [] },
  surface: { heading: "Surface / finish", visibleLimit: 5, alwaysVisible: [] },
} as const;

export type CompactFilterKey = keyof typeof productFilterCompaction;

export function getCompactFilterValues({
  values,
  activeValues,
  visibleLimit,
  alwaysVisible = [],
  expanded,
}: {
  values: string[];
  activeValues: string[];
  visibleLimit: number;
  alwaysVisible?: readonly string[];
  expanded: boolean;
}): string[] {
  if (expanded) return values;

  const visible = new Set([...values.slice(0, visibleLimit), ...activeValues, ...alwaysVisible]);
  return values.filter((value) => visible.has(value));
}
